import { Vue, Component, Watch } from 'vue-property-decorator';
import TransmissionPages from './transmission-pages';

@Component
export default class Transmissions extends Vue {
  currentPage = TransmissionPages.messages;
  TransmissionPages = TransmissionPages;

  @Watch('currentPage')
  currentPageUpdated(newPageName) {
    if (this.$route.name === newPageName) return;

    this.$router.push({
      name: newPageName,
    });
  }

  created() {
    this.currentPage = this.$route.name as any;
  }
}
